import React, { Component } from "react";
import Loading from './../components/loading';
import { Bounce, Fade } from 'react-reveal';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Carousel from 'react-bootstrap/Carousel'
import Image from 'react-bootstrap/Image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'


const ContentStyles = styled.div`


`;

class SliderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };
  }

  async componentDidMount() {
    await fetch("/json/slider.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            mode: 'no-cors',
            method: "post",
            headers: {
              "Content-Type": "application/json"
            },
            items: result
          });
        },
        // Not: Burada hataları yakalamak önemlidir.
        // Bileşenimizde bug bulunmaması için, 'catch ()' bloğu yerine bulunan
        // bu blok içinde hatalar yakalanır.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }
  render() {
    const directionButtons = (direction) => {

      return (
        <FontAwesomeIcon icon={direction === "Next" ? faChevronRight : faChevronLeft} />
      );
    };
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {
      return (
        <>
          <ContentStyles>
            <Carousel
              Fade
              nextLabel={"Sonraki"}
              prevLabel={"Önceki"}
              nextIcon={directionButtons("Next")}
              prevIcon={directionButtons("Previous")}
              className="mortgageBigCarousel"
            >
              {
                items.map((slider, i) => {
                  return (

                    <Carousel.Item key={i}>
                      <Container>
                        <Row>
                          <Col sm={6}>
                            <Carousel.Caption>
                              <Bounce left>
                                <h3>{slider.name}</h3>
                              </Bounce>
                              <Fade bottom delay={500}>
                                <p className="description d-none d-lg-block d-md-block">{slider.description}</p>
                              </Fade>
                              <Fade bottom delay={800}>
                                <Button className="d-none d-lg-inline-block d-md-inline-block" variant="outline-primary" href={slider.link}>İNCELE</Button>
                              </Fade>
                            </Carousel.Caption>
                          </Col>
                          <Col sm={6}>
                            <Fade>
                              <Image className="d-block" src={`${slider.featuredimage}`} alt={slider.name} fluid />
                            </Fade>
                          </Col>
                        </Row>
                      </Container>
                    </Carousel.Item>
                  );
                })
              }
            </Carousel>
          </ContentStyles>
        </>
      );
    }
  }
}

export default SliderComponent;